const getThemeVariable = (name: string) =>
  getComputedStyle(document.documentElement)
    .getPropertyValue(`--${name}`)
    .trim();

export const getThemeVariables = () => ({
  colors: {
    primary: getThemeVariable('primary-color'),
    'primary-light': getThemeVariable('primary-color-light'),
    'primary-dark': getThemeVariable('primary-color-dark'),
    info: getThemeVariable('info-color'),
    'info-light': getThemeVariable('info-color-light'),
    'info-dark': getThemeVariable('info-color-dark'),
    secondary: getThemeVariable('secondary-color'),
    'secondary-light': getThemeVariable('secondary-color-light'),
    'secondary-dark': getThemeVariable('secondary-color-dark'),
    tertiary: getThemeVariable('tertiary-color'),
    'tertiary-light': getThemeVariable('tertiary-color-light'),
    'tertiary-dark': getThemeVariable('tertiary-color-dark'),
    success: getThemeVariable('success-color'),
    'success-light': getThemeVariable('success-color-light'),
    'success-dark': getThemeVariable('success-color-dark'),
  },
  breakpoints: {
    xs: 0,
    sm: parseInt(getThemeVariable('breakpoint-sm'), 10),
    md: parseInt(getThemeVariable('breakpoint-md'), 10),
    lg: parseInt(getThemeVariable('breakpoint-lg'), 10),
    xl: parseInt(getThemeVariable('breakpoint-xl'), 10),
  },
});

export type ThemeColorVariables = ReturnType<
  typeof getThemeVariables
>['colors'];

export type ThemeColors =
  | keyof ReturnType<typeof getThemeVariables>['colors']
  | 'black'
  | 'white'
  | '';

export type ThemeBreakpointVariables = ReturnType<
  typeof getThemeVariables
>['breakpoints'];

export type ThemeBreakpoints =
  | keyof ReturnType<typeof getThemeVariables>['breakpoints'];
